var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b9e2489f9ec55b21c2d1d694aa2ba8b6dec91e62"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["signal@codingcafe_jp"]={id:"b9e2489f9ec55b21c2d1d694aa2ba8b6dec91e62"};
      